import { render, staticRenderFns } from "./ProjectData.vue?vue&type=template&id=66e27c60&scoped=true&"
import script from "./ProjectData.vue?vue&type=script&lang=js&"
export * from "./ProjectData.vue?vue&type=script&lang=js&"
import style0 from "./ProjectData.vue?vue&type=style&index=0&id=66e27c60&prod&scoped=true&lang=css&"
import style1 from "./ProjectData.vue?vue&type=style&index=1&id=66e27c60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e27c60",
  null
  
)

export default component.exports